import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'placement-details',
    templateUrl: './templates/placement-details.component.html',
    styleUrls: ['./styles/products-list.component.css', './styles/placement-details.component.css']
})
export class PlacementDetailsComponent implements OnInit {

    @Input() details_docket: Array<any> = [];
    @Input() docket_infos: string;
    @Output() place = new EventEmitter();
    @Output() article_to_place = new EventEmitter();
    @Output() article_to_view = new EventEmitter();

    constructor() {}

    ngOnInit() {
    }

    Cancel() {
        this.place.emit("CANCEL");
    }

    PlaceOnLine(docket: any) {
        this.article_to_place.emit(docket);
    }

    ViewOnLine(docket: any) {
        this.article_to_view.emit(docket);
    }

    setStyles(value: any) {
        if (Number(value) <= 1) {
            let styles = {
                'width': '32%',
            };
            return styles;
        } else {
            let styles = {
                'width': '16%',
            };
            return styles;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/placement-details.component.ts